"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remove = exports.destroy = exports.updateConfig = exports.showMessage = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _notice = _interopRequireDefault(require("./notice"));

var _rcAnimate = _interopRequireDefault(require("rc-animate"));

var _spauiPortal = _interopRequireDefault(require("@tencent/spaui-portal"));

var _index = require("./utils/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// 消息组件
var Message =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Message, _React$PureComponent);

  function Message(props) {
    var _this;

    _classCallCheck(this, Message);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Message).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getNoticeId", function () {
      var notices = _this.state.notices;
      return "notice-".concat(new Date().getTime(), "-").concat(notices.length);
    });

    _defineProperty(_assertThisInitialized(_this), "addNotice", function () {
      var originNotice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var globalConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$state = _this.state,
          notices = _this$state.notices,
          config = _this$state.config;

      var newConfig = _objectSpread({}, config, {}, globalConfig);

      var duration = newConfig.duration,
          maxCount = newConfig.maxCount;

      var notice = _objectSpread({}, originNotice, {
        // 如果 props 中有 id，则使用该 id, 否则生成一个 id
        id: (0, _spauiUtils.isUndefined)(originNotice.id) ? _this.getNoticeId() : originNotice.id,
        // 如果没有设置默认关闭时间，则从全局配置中获取
        duration: (0, _spauiUtils.isUndefined)(originNotice.duration) ? duration : originNotice.duration
      }); // 检查下这个 id 是否已经存在了，如果已经存在了，则更新该 message 的 props


      var isExistNotice = notices.some(function (item) {
        return item.id === notice.id;
      }); // 存在则更新

      if (isExistNotice) {
        var newNotices = notices.map(function (item) {
          if (item.id === notice.id) {
            var newNotice = _objectSpread({}, notice);

            clearTimeout(item._timeoutId);

            if (notice.duration > 0) {
              var timeoutId = setTimeout(function () {
                _this.removeNotice(item.id, true);
              }, (0, _index.accMul)(notice.duration, 1000));
              newNotice._timeoutId = timeoutId;
            }

            return newNotice;
          }

          return item;
        });

        _this.setState({
          notices: newNotices,
          config: newConfig
        });
      } else {
        if (notice.duration > 0) {
          var timeoutId = setTimeout(function () {
            _this.removeNotice(notice.id, true);
          }, (0, _index.accMul)(notice.duration, 1000)); // 存储 timeoutId，用于更新消息 Props 时，清除之前的自定消失定时器

          notice._timeoutId = timeoutId;
        }

        var _newNotices = notices.concat(notice);

        _this.setState({
          notices: _newNotices.length <= maxCount ? _newNotices : _newNotices.slice(1),
          config: newConfig
        });
      }

      return function () {
        _this.removeNotice(notice.id, false);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "removeNotice", function (id, isAutoClose) {
      var notices = _this.state.notices;

      _this.setState({
        notices: notices.filter(function (notice) {
          if (notice.id === id) {
            if (notice.onClose) {
              notice.onClose(isAutoClose, notice);
            }

            return false;
          }

          return true;
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateConfig", function () {
      var newConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var config = _this.state.config;

      _this.setState({
        config: _objectSpread({}, config, {}, newConfig)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "mouseLeaveTimer", null);

    _this.state = {
      notices: [],
      // Message 的全局配置
      config: {
        duration: 3,
        // 默认关闭时间 3 秒
        maxCount: Infinity,
        // 最大显示数, 超过限制时，最早的消息会被自动关闭
        top: undefined,
        // 消息距离顶部的位置
        portalClassName: '',
        portalStyle: {},
        transitionName: 'move-up',
        // 动画样式名称
        position: 'center',
        collapsible: false // 新增可配置是否收起，默认保持不收起

      },
      // 记录每个消息的高度
      heights: [],
      // 是否收起
      collapsed: true
    };
    return _this;
  }

  _createClass(Message, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    } // 生成通知的 Id

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state2 = this.state,
          notices = _this$state2.notices,
          _this$state2$config = _this$state2.config,
          portalClassName = _this$state2$config.portalClassName,
          transitionName = _this$state2$config.transitionName,
          top = _this$state2$config.top,
          position = _this$state2$config.position,
          portalStyle = _this$state2$config.portalStyle,
          collapsible = _this$state2$config.collapsible,
          collapsed = _this$state2.collapsed,
          heights = _this$state2.heights;
      return _react["default"].createElement(_spauiPortal["default"], {
        className: (0, _classnames["default"])('spaui-message-portal', portalClassName, "".concat(position, "-portal")),
        style: _objectSpread({
          paddingTop: top,
          // 默认的 overflow auto 会产生滚动条
          overflow: 'visible'
        }, portalStyle || {})
      }, _react["default"].createElement("div", {
        onMouseEnter: function onMouseEnter() {
          clearTimeout(_this2.mouseLeaveTimer);

          _this2.setState({
            collapsed: false
          });
        },
        onMouseLeave: function onMouseLeave() {
          clearTimeout(_this2.mouseLeaveTimer);
          _this2.mouseLeaveTimer = setTimeout(function () {
            _this2.setState({
              collapsed: true
            });
          }, 200);
        }
      }, _react["default"].createElement(_rcAnimate["default"], {
        transitionName: transitionName,
        component: "div"
      }, _toConsumableArray(notices).reverse().map(function (notice, index) {
        return _react["default"].createElement(_notice["default"], _extends({
          collapsible: collapsible,
          collapsed: collapsed,
          heights: heights,
          setHeights: function setHeights(heights) {
            _this2.setState({
              heights: heights
            });
          },
          index: index,
          key: notice.id
        }, notice, {
          removeNotice: _this2.removeNotice
        }));
      }))));
    }
  }]);

  return Message;
}(_react["default"].PureComponent); // 组件标记


(0, _spauiUtils.setComponentMark)(Message, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled'); // Message 组件实例（默认是单实例，支持多实例）

var defaultInstanceId = 'one-design-message';

var messageInstance = _defineProperty({}, defaultInstanceId, {
  mounting: false,
  waitOpens: [],
  waitConfig: {},
  instance: null
});
/**
 * 显示消息
 * @param {object} notice 消息体内容
 * @param {object} config 需要更新的配置
 */


var showMessage = function showMessage(notice, config) {
  var instanceId = defaultInstanceId;

  if (notice) {
    instanceId = notice.instanceId || defaultInstanceId;
  } else if (config) {
    instanceId = config.instanceId || defaultInstanceId;
  } // 是一个新的实例，初始化下实例的默认配置


  if (!messageInstance[instanceId]) {
    messageInstance[instanceId] = {
      mounting: false,
      waitOpens: [],
      waitConfig: {},
      instance: null
    };
  }

  var instanceInfo = messageInstance[instanceId];

  if (!instanceInfo.instance) {
    // 创建实例到实例创建成功之前所有显示的操作都要进入等待队列
    if (notice) {
      instanceInfo.waitOpens.push(notice);
    }

    if (config) {
      instanceInfo.waitConfig = config;
    }

    if (!instanceInfo.mounting) {
      // 创建实例
      var div = document.createElement('div');
      instanceInfo.mounting = true;
      instanceInfo.container = div;
      document.body.appendChild(div);

      _reactDom["default"].render(_react["default"].createElement(Message, {
        ref: function ref(component) {
          instanceInfo.instance = component;
        }
      }), div, function () {
        // 显示等待队列中的弹框
        instanceInfo.mounting = false;

        if (instanceInfo.instance) {
          instanceInfo.waitOpens.forEach(function (noticeItem) {
            instanceInfo.instance.addNotice(noticeItem, instanceInfo.waitConfig);
          });
        }
      });
    } // hack: 目前改成非同步的模式，实例可能还没有创建完成，无法返回的一个删除消息的回调，所以先返回一个空函数做兼容。


    return function () {
      /* eslint-disable no-console */
      console.log('One-Design Log: 删除消息体请使用另外一种方式，详情见官网案例.');
    };
  }

  if (notice) {
    return instanceInfo.instance.addNotice(notice, instanceInfo.waitConfig);
  }
};
/**
 * 更新消息实例的配置
 * @param {object} config
 */


exports.showMessage = showMessage;

var updateConfig = function updateConfig(config) {
  var instanceInfo = messageInstance[config.instanceId || defaultInstanceId]; // 如果实例不存在，那么需要先创建实例并直接更新配置

  if (!instanceInfo || !instanceInfo.instance) {
    showMessage(null, config);
  } else {
    instanceInfo.waitConfig = config;
    instanceInfo.instance.updateConfig(config);
  }
};
/**
 * 销毁消息实例
 * @param {object} config
 */


exports.updateConfig = updateConfig;

var destroy = function destroy() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var instanceInfo = messageInstance[config.instanceId || defaultInstanceId];

  if (!instanceInfo || !instanceInfo.instance) {
    return;
  }

  if (instanceInfo.container) {
    _reactDom["default"].unmountComponentAtNode(instanceInfo.container);

    document.body.removeChild(instanceInfo.container);
    instanceInfo.instance = undefined;
  }
};
/**
 * 删除消息
 * @param {object} config
 */


exports.destroy = destroy;

var remove = function remove(config) {
  var instanceInfo = messageInstance[config.instanceId || defaultInstanceId];

  if (!instanceInfo || !instanceInfo.instance) {
    return;
  }

  instanceInfo.instance.removeNotice(config.id, false);
};

exports.remove = remove;